module.exports = __webpack_public_path__ + "img/d0deb0b.png";